import { combineReducers } from '@reduxjs/toolkit';

import invoicesReducer from './payments/invoices/slice';
import statusReducer from './payments/status/slice';

import applicationsReducer from './workflows/applications/slice';
import authorizationsReducer from './workflows/authorizations/slice';
import notificationsReducer from './workflows/notifications/slice';
import receiptsReducer from './payments/reciepts/slice';
import outstandingBalanceReducer from './outstandingBalance/slice';

const paymentsReducer = combineReducers({
  invoices: invoicesReducer,
  status: statusReducer,
  receipts: receiptsReducer,
});

const workflowsReducer = combineReducers({
  applications: applicationsReducer,
  authorizations: authorizationsReducer,
  notifications: notificationsReducer,
});

const customerReducer = combineReducers({
  payments: paymentsReducer,
  workflows: workflowsReducer,
  outstandingBalance: outstandingBalanceReducer,
});

export default customerReducer;
